var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "document-library-card", attrs: { href: _vm.item.url } },
    [
      _vm.item.image && _vm.item.image.url
        ? _c("div", { staticClass: "document-library-card__image-frame" }, [
            _c("img", {
              staticClass: "document-library-card__image",
              attrs: {
                width: "84",
                height: "117",
                src: _vm.item.image.url,
                alt: _vm.item.image.alt
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "document-library-card__content" }, [
        _vm.item.tags.length
          ? _c(
              "div",
              { staticClass: "document-library-card__tags" },
              _vm._l(_vm.item.tags, function(item) {
                return _c("div", { key: item }, [_vm._v(_vm._s(item))])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("h3", { staticClass: "document-library-card__heading" }, [
          _vm._v(_vm._s(_vm.item.heading))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "document-library-card__button-holder" }, [
          _c(
            "div",
            {
              staticClass:
                "c-button c-button--small c-button--brand c-button--font-heading c-button--bg-color-brand-nine"
            },
            [
              _c(
                "svg",
                {
                  staticClass: "c-button__icon c-button__icon--alt",
                  attrs: { "aria-hidden": "true", focusable: "false" }
                },
                [
                  _c("use", {
                    attrs: {
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      "xlink:href": "#download"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "c-button__inner" }, [
                _vm._v(
                  _vm._s(_vm.item.document.type) +
                    " - " +
                    _vm._s(_vm.item.document.size)
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f9b4144", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f9b4144","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/document-library/DocumentLibraryCard.vue
// module id = 618
// module chunks = 0